export default __webpack_public_path__ + "static/media/signup.940c7b37.png";